var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 25,
    viewBox: "0 0 25 25",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#000",
      strokeWidth: 1.5,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(1 1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.5006463 11.2506463c.0000892-1.63522366-1.0591558-3.0820762-2.618-3.57600004.7533116-1.45119391.4795257-3.22319269-.6766408-4.37935924-1.1561666-1.15616654-2.9281653-1.4299524-4.3793592-.67664076-.4936949-1.55909998-1.9406018-2.61864626-3.576-2.61864626-1.63539826 0-3.08230522 1.05954628-3.57600004 2.61864626-1.45119391-.75331164-3.22319269-.47952578-4.37935924.67664076-1.15616654 1.15616655-1.4299524 2.92816533-.67664076 4.37935924-1.55909998.49369482-2.61864626 1.94060178-2.61864626 3.57600004 0 1.6353982 1.05954628 3.0823051 2.61864626 3.576-.75331164 1.4511939-.47952578 3.2231926.67664076 4.3793592 1.15616655 1.1561665 2.92816533 1.4299524 4.37935924.6766408.49369482 1.5590999 1.94060178 2.6186462 3.57600004 2.6186462 1.6353982 0 3.0823051-1.0595463 3.576-2.6186462 1.4511939.7533116 3.2231926.4795257 4.3793592-.6766408 1.1561665-1.1561666 1.4299524-2.9281653.6766408-4.3793592 1.5586484-.4941965 2.6177701-1.9408807 2.618-3.576z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.68181818 9.09090909v4.36363641"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.5 11.2727273h4.3636364"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m13.0454545 8h1.0909091v6.5454545"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.29c4cd0b278a1c09b7d4ff416c161c2c.svg";
export { ForwardRef as ReactComponent };